export default __webpack_public_path__ + "static/media/a08fa92e7226403dca92f9a95e654f26.49f988ce.png";